module.exports = __webpack_public_path__ + "static/media/course-placeholder.3d1257f3.svg";